import AbstractGuestlistDetailsPageController from './abstract-details-controller';

export default class GuestlistCenterStagePageController extends AbstractGuestlistDetailsPageController {
    constructor($scope, $injector) {
        super($scope, $injector);
        this.auth = this.injector.get('$auth');

        this.centerStageEmbedUrl = this.injector.get('Env').center_stage_embed_url;
    }

    _startIframe() {
        console.log('start iframe');
        const iFrameDocument = document.getElementById('center-stage-iframe').contentWindow.document;
        let form = iFrameDocument.createElement("form");
        form.setAttribute("method", "post");
        form.setAttribute("action", this.centerStageEmbedUrl);
        form.setAttribute("target", "_self");

        const fieldsToSet = {
            token: this.auth.getToken(),
            username: this.userStore.state.loggedin.profile.full_name,
            company_uid: this.userStore.state.company.uid,
            company_name: this.userStore.state.company.name,
            guestlist_uid: this.guestlist.uid,
            guestlist_title: this.guestlist.name,
            guestlist_id: this.guestlist.id,
        }

        _.each(fieldsToSet, (v, k) => {
            const curField = iFrameDocument.createElement("input");
            curField.setAttribute("type", "hidden");
            curField.setAttribute("name", k);
            curField.setAttribute("value", v);
            form.appendChild(curField);
        })

        iFrameDocument.body.appendChild(form);
        form.submit();
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/controllers/pages/guestlists/centerstage-controller.js